import React from "react";
import Select from "react-select";

const Filter = ({
  isOpen,
  onClose,
  filterFields = [],
  filters,
  setFilters,
  applyFilters,
  clearFilters,
}) => {
  const handleInputChange = (e, name) => {
    setFilters((prev) => ({ ...prev, [name]: e.target.value }));
  };

  const handleSelectChange = (selected, name) => {
    setFilters((prev) => ({
      ...prev,
      [name]: selected ? selected.value : "",
    }));
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={onClose}
        />
      )}
      <div
        className={`fixed top-[100px] right-0 w-full sm:w-[360px] h-[calc(100%-64px)] bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="overflow-y-auto h-full">
          {/* Header */}

          <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h3 className="text-base font-semibold text-[#405189]">Filter</h3>
            <div className="flex items-center gap-3">
              <button
                className="text-gray-500 hover:text-red-600 text-xl"
                onClick={onClose}
              >
                ✕
              </button>
            </div>
          </div>

          {/* Dynamic Fields */}
          <div className="flex flex-wrap gap-y-4 gap-x-3 p-5">
            {filterFields.map((field) => (
              <div
                key={field.name}
                className={`${field.type === "toggle" ? "flex-1 min-w-[140px]" : "w-full"}`}
              >
                {field.type !== "toggle" && (
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {field.label}
                  </label>
                )}
                {field.type === "select" ? (
                  <Select
                    options={field.options || []}
                    value={
                      field.options?.find(
                        (opt) => opt.value === filters[field.name]
                      ) || null
                    }
                    isClearable
                    isSearchable
                    onChange={(selected) =>
                      handleSelectChange(selected, field.name)
                    }
                    className="text-sm"
                    classNamePrefix="react-select"
                  />
                ) : field.type === "toggle" ? (
                  <div className="flex items-center justify-between p-2.5 bg-gray-50/50 rounded-xl border border-gray-100/50 transition-all hover:bg-gray-50 h-full">
                    <span className="text-[13px] font-semibold text-gray-700 whitespace-nowrap">
                      {field.label}
                    </span>
                    <label className="relative inline-flex items-center cursor-pointer ml-2">
                      <input
                        type="checkbox"
                        checked={filters[field.name] || false}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            [field.name]: e.target.checked,
                          }))
                        }
                        className="sr-only peer"
                      />
                      <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary shadow-sm"></div>
                    </label>
                  </div>
                ) : (
                  <input
                    type={field.type || "text"}
                    name={field.name}
                    placeholder={field.placeholder || ""}
                    value={filters[field.name] || ""}
                    onChange={(e) => handleInputChange(e, field.name)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary focus:outline-none transition-all"
                  />
                )}
              </div>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="flex justify-between gap-3 p-5 ">
            <button
              className="w-1/2 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium transition"
              onClick={() => {
                clearFilters();
                onClose();
              }}
            >
              Clear
            </button>
            <button
              className="w-1/2 py-2 rounded-lg bg-primary hover:bg-primary-dark text-white text-sm font-medium transition"
              onClick={applyFilters}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Filter;
